'use client';

import { useEffect, useRef } from 'react';

const useFunkyConsoleMessage = () => {
  const displayed = useRef(false);

  useEffect(() => {
    if (displayed.current) {
      return;
    }

    const logo = `
                                   :::                                                              
                                   :::                                                              
:::   :::   :::   ::::::   :::::::::::   :::: ::::::   ::: :::::    :::::::      :::::      ::::::  
:::  ::::  :::: :::::::::: ::::::::::: ::::::::::::::: ::::::::::: ::::::::::  ::::::::: :::::::::: 
 ::: ::::: ::: ::::    :::::::::   :::::::  :::::  ::: ::::   :::: :::  ::::: ::::   :::::::    ::::
 ::::::::::::: :::     ::::::::    :::::::   ::::::::: :::     :::::::::::::: :::        :::::::::::
  ::::: :::::  ::::    ::::::::    ::: :::: :::  ::::: ::::    ::: ::::   ::: :::     ::::::     :::
  ::::: :::::   :::::::::: ::::    :::  :::::::::::::: ::::::::::: :::::::::: ::::::::::::::::::::::
   :::   :::     :::::::   ::::    :::   ::::::::::::  :::::::::    :::::::::   :::::::    :::::::  
                                                       :::                                          
                                                       :::                                          
    `;

    // eslint-disable-next-line no-console
    console.log(logo);

    displayed.current = true;
  }, []);
};

export default useFunkyConsoleMessage;
